import type {GetShopsParams, ShopRepository} from "../model/repository";
import {Shop} from "../model/types";
import {httpClient} from "@/shared/api/httpClient";

type GetShopsResponse = {
    success?: {
        status: boolean;
        shops: Shop[];
    };
};

const ENDPOINT = "/get_shops_all";

export class ShopHttpRepository implements ShopRepository {
    async getShops(params: GetShopsParams): Promise<Shop[]> {
        const response = await httpClient.post<GetShopsResponse>(ENDPOINT, params);

        const {success} = response.data;

        if (!success?.status) {
            return [];
        }

        return success.shops ?? [];
    }
}
